import { followingRoutes } from './apiRoutes';
import { axiosAuthInstance } from './auth';

export const add_following = (body) => axiosAuthInstance.post(followingRoutes.add_following, body);
export const get_following_data = (queryParams) => axiosAuthInstance.get(followingRoutes.get_following, { params: queryParams });

export const set_auction_timeprice = (body) => axiosAuthInstance.post(followingRoutes.set_auction_timeprice, body);
